module.exports = __webpack_public_path__ + "img/8e403a813ade25056560a1f8da9f425f.png";